import { Card } from "@uno/protocol";

export const CARD_WIDTH = 100;
export const CARD_HEIGHT = 135;

export type CardProps = {
    isHoverable: boolean;
    positionInDiscardStack?: number;
    style?: React.CSSProperties;
} & Card;
